(function () {
    'use strict';

    angular
        .module('app')
        .factory('ImageService', ImageService);

    function ImageService($http, $q, WebAPIUrl, WebApiService) {

        var service = {
            uploadImage: uploadImage,
            deleteImage: deleteImage,
            getFileTypeConfigInfo: getFileTypeConfigInfo,
            downloadFile: downloadFile,
            defaultImageUrl: defaultImageUrl,
            invalidateCache: invalidateCache
        };

        return service;

        function uploadImage(file, imageMeta) {
            var deferred = $q.defer();

            var fd = new FormData();
            fd.append("file", file);
            
            $http.post(WebAPIUrl + "/api/Image/UploadImage?projectId=" + imageMeta.ProjectId + "&projectLevel=" + imageMeta.ProjectLevel + "&imageType=" + imageMeta.ImageType, fd, {
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined },
                ignoreLoadingBar: true
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        }

        function deleteImage(projectId, projectLevel, imageType) {

            var deferred = $q.defer();
            $http({
                method: 'POST',
                url: WebAPIUrl + '/api/Image/DeleteImage?ProjectId=' + projectId + '&ProjectLevel=' + projectLevel + '&imageType=' + imageType,
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        }

        function getFileTypeConfigInfo(fileTypeId) {

            var deferred = $q.defer();
            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/Image/FileTypeConfigInfo?FileTypeId=' + fileTypeId,
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        }

        function downloadFile() {
            alert('entered service');
            var deferred = $q.defer();
            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/Image/DownloadFile'              
            }).success(function (data, status, headers, cfg) {
                alert(data);
                deferred.resolve(data);
            }).error(function (err, status) {
                alert('error');
                deferred.reject(err, status);
            });

            return deferred.promise;
        }

        function defaultImageUrl(size) {
            return WebAPIUrl + "/api/Image/DefaultImage?size=" + size;
        }

        function invalidateCache(projectId, projectLevel) {
            return WebApiService.postJson("/api/Image/InvalidateCache?projectId=" + projectId + "&projectLevel=" + projectLevel);
        }
    }

})();
